import RedesignDescriptor from './accountReady-redesign';
import RefiveDescriptor from './accountReady-refive';
import CanteenDescriptor from './accountReady-canteen';
import CompanyKitchenDescriptor from './accountReady-companykitchen';
import AramarkDescriptor from './accountReady-aramark';
import Settings from 'src/Settings';
import {BuildTypeEnum} from 'src/constants/BuildTypeEnum';

const typeDescriber = {
  [BuildTypeEnum.aramark]: AramarkDescriptor,
  [BuildTypeEnum.canteen]: CanteenDescriptor,
  [BuildTypeEnum.default]: RedesignDescriptor,
  [BuildTypeEnum.companykitchen]: CompanyKitchenDescriptor,
  [BuildTypeEnum.refive]: RefiveDescriptor,
};

export function getDescriber() {
  return typeDescriber[Settings.buildType as keyof typeof typeDescriber];
}
